<template>
  <div class="box-wrap">
    <div class="row">
      <div class="col-xs-12 col-lg-8 col-lg-offset-2">
        <div class="form-horizontal">
          <div class="form-group">
            <label class="col-xs-4 col-lg-2 control-label mimput-label">{{changePasswordLan.loginId}}</label>
            <div class="col-xs-8 col-lg-10">
              <input type="text" class="form-control" v-model="login" disabled>
            </div>
          </div>
          <div class="form-group">
            <label class="col-xs-4 col-lg-2 control-label mimput-label">{{changePasswordLan.oldPwd}}</label>
            <div class="col-xs-8 col-lg-10">
              <input type="password" class="form-control" v-model="oldPwd" :disabled="viewReadOnly">
            </div>
          </div>
          <div class="form-group">
            <label class="col-xs-4 col-lg-2 control-label mimput-label">{{changePasswordLan.newPwd}}</label>
            <div class="col-xs-8 col-lg-10">
              <input v-validate="'required'" name="newPwd" type="password" class="form-control" v-model="newPwd" :disabled="viewReadOnly" ref="newPwd">
              <div v-show="errors.has('newPwd')" class="failed-modal">{{changePasswordLan.errTips.newPwd}}</div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-xs-4 col-lg-2 control-label mimput-label">{{changePasswordLan.confirmPwd}}</label>
            <div class="col-xs-8 col-lg-10">
              <input v-validate="'required|confirmed:newPwd'" name="confirmPwd" type="password" class="form-control" :disabled="viewReadOnly">
              <div v-show="errors.has('confirmPwd')" class="failed-modal">{{changePasswordLan.errTips.confirmPwd}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="btn btn-primary" @click="saveFn" :disabled="viewReadOnly">{{changePasswordLan.saveBtn}}</button>
    </div>
  </div>
</template>

<script>
import { URL_PASSWORD } from 'api/api.js'
export default {
  mixins: [require("@/common/mixin/base.js").base({ changePasswordLan: "changePassword" })],
  props: ['viewReadOnly'],
  data() {
    return {
      oldPwd: '',
      newPwd: '',
    }
  },
  computed: {
    requestData() {
      return {
        oldPwd: this.oldPwd,
        newPwd: this.newPwd,
      }
    },
    login() {
      return JSON.parse(sessionStorage.user).name
    }
  },
  methods: {
    saveFn() {
      this.$validator.validate().then(res => {
        if(res){
          this.$http.put(URL_PASSWORD,this.requestData).then(res => {
            if(res.data.code === 200 && res.data.data === 'success') {
              alert(this.changePasswordLan.success)
              this.$router.push('/login')
            }else alert(res.data.msg)
          }).catch(e => alert(e))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box-wrap{
  margin: 0 20px 20px;
  padding: 20px;
  border: 1px solid #ddd;
  background: #fff;
  .mimput-label{
    height: 34px;
    line-height: 34px;
    padding-top: 0;
    text-align: center;
    white-space: nowrap;
  }
  .footer{
    margin: 20px 0;
    text-align: center;
    .btn{
      padding: 8px 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/changePassword/changePassword.vue